import Vue from 'vue';

import {
  library
} from '@fortawesome/fontawesome-svg-core';
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';

// SOLID ICONS
import {
  faUserSecret,
  faBiking,
  faGlassCheers,
  faParking,
  faClock,
  faPaw
} from '@fortawesome/free-solid-svg-icons';
library.add(faUserSecret, faBiking, faGlassCheers, faParking, faClock, faPaw);

// BRAND ICONS
import {
  faFacebookSquare,
  faInstagramSquare,
  faWhatsapp,
  faWaze,
  faTripadvisor
} from '@fortawesome/free-brands-svg-icons';
library.add({
  faFacebookSquare,
  faInstagramSquare,
  faWhatsapp,
  faWaze,
  faTripadvisor
});

// REGULAR ICONS
import {
  faLaughBeam,
  faCalendarAlt,
  faClipboard,
  faCreditCard,
  faThumbsUp,
  faThumbsDown,
  faCommentDots
} from '@fortawesome/free-regular-svg-icons';
library.add({
  faLaughBeam,
  faCalendarAlt,
  faClipboard,
  faCreditCard,
  faThumbsUp,
  faThumbsDown,
  faCommentDots
});

Vue.component('font-awesome-icon', FontAwesomeIcon);